<div class="bolseiros-list">
  <div *ngFor="let bolseiro of bolseiros" class="bolseiro-item">
    <app-card-person-bolseiros [bolseiro]="bolseiro">
    </app-card-person-bolseiros>
  </div>
</div>
